module.exports = __webpack_public_path__ + "img/page-bg-zh.cbdc2a15.png";